<template lang="pug">
.product-purchase-history
  GenericCard.productList(size='85' :ignoreMaxWidth='true')
    .sticky-top.bg-white
      .d-flex.px-4.py-4
        CustomerCompactDetailHeader(:data='customer')

        PanelTitleRight.ml-auto(
          title='ประวัติการซื้อ<br>ตามรายการสินค้า'
          v-model='filterDate'
        )
      .d-flex.align-items-end.px-4.py-2
        //- CustomCategoriesFilter(
        //-   title='เลือกดูรายการ'
        //-   :items='statusList'
        //-   v-model='filterStatus'
        //- )
        CustomSearchBox.w-100(
          v-model='filterSearch'
          type='text' placeholder='ค้นหาด้วยชื่อสินค้าหรือรหัสสินค้า'
          width='100%'
          :isLoading='isLoading'
        )

      hr.mb-0

    LoadedContentWrapper.flex-fill(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      .py-2.px-3.h-scrollable
        CustomTable(
          :columns='tableColumns'
          :data='filteredTableData'
          :showIndexes='true'
          :showNotificationDots='true'
          @itemClicked='showModal'
        )
      .sticky-bottom.bg-white
        hr.m-0
        .px-4.py-3
          CustomPagination(
            v-model='currentPage'
            :total='totalPage'
          )

  modal(
    name='sell-record'
    width='800' height='600'
    transition='modal-transition'
  )
    CSProductStat(
      :product='selectedItem'
      @closeButtonClicked='hideModal'
    )

</template>

<script>
/* eslint-disable arrow-body-style */
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';
// import SellRecordDetail from '@/components/history/dialogs/SellRecord/SellRecordDetail.vue';
import CSProductStat from '../dialogs/CSProductStat.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
  },
  watch: {
    // reload data
    filterDate: {
      deep: true,
      handler() { this.currentPage = 1; this.loadData(); },
    },
    customer() { this.currentPage = 1; this.loadData(); },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      // return this.tableData.filter((item) => {
      //   return !KEYWORD
      //           || (item.productName && item.productName.toUpperCase().includes(KEYWORD))
      //        || (item.productId && item.productId.toString().toUpperCase().startsWith(KEYWORD));
      // });
      return this.tableData;
    },
  },
  data() {
    return {
      isLoading: false,

      // // statusList: this.$api.customer.ORDER_STATUS,
      // statusList: {
      //   0: 'รออนุมัติ',
      //   1: 'อนุมัติ',
      //   2: 'ไม่อนุมัติ',
      // },
      // filterStatus: '',

      filterDate: '',
      filterSearch: '',
      tableData: [],
      tableColumns: {
        productId: {
          title: 'รหัสสินค้า',
          align: 'center',
        },
        productName: {
          title: 'ชื่อสินค้า',
          align: 'left',
        },
        productGroupId: {
          title: 'กลุ่มสินค้า',
          align: 'center',
        },
        amount: {
          title: 'จำนวน',
          align: 'right',
        },
        priceWithComm: {
          title: 'ราคาขายรวมคอม',
          align: 'right',
          type: Number,
          // computed: row => row.productPrice,
          computed: row => (Number(row.total) / row.amount),
        },
        total: {
          title: 'ยอดรวม',
          align: 'right',
          type: Number,
          // computed: row => (row.price),
        },
      },

      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItem: {},
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // reset data
      this.tableData = null;

      try {
        const res = await this.$api.customer.history.productPurchase(
          this.customer.id,
          this.currentPage,
          this.filterDate.from,
          this.filterDate.to,
          this.filterSearch,
        );
        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    showModal(e) {
      this.selectedItem = e.data;
      this.$modal.show('sell-record');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('sell-record');
      this.loadData();
    },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    this.loadData();
  },
  components: {
    CustomerCompactDetailHeader,
    CSProductStat,
  },
};
</script>

<style lang="scss">
// .product-purchase-history {}
</style>
